
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getAreaOnScenario",
      resolverType: "query",
      routePath: "/getAreaOnScenario",
      httpMethod: "POST",
    });
  